//是否登录
const ISlogin = function() {
	var that = this;
	var resStore = "";
	var token = localStorage.getItem("Uetoken");
	$.ajax({
		type: "post",
		headers: {
			'client_id': 'Ue',
			'Authorization': 'Bearer ' + token,
			'Store': 1, //
		},
		url: that.$port.httpUrl.GetIsLogin,
		data: {},
		dataType: "json",
		async: false,
		success: function(data) {
			if(data.success == false) {
				that.$router.push({path: '/customer/login'});

			} 
			resStore = data.result;
		}
	});
	return resStore;
}
export default {
	ISlogin
}


// WEBPACK FOOTER //
// ./src/js/util.js